function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import cn from 'classnames';
import isBoolean from 'lodash/isBoolean';
import T from 'prop-types';
import React from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import text from '../../text';
import Icon from '../icon/Icon';
import { useSelector } from 'react-redux';
import { profileSelectors } from '../../redux/selectors/profile';
var NavLinkContent = function(param) {
    var icon = param.icon, isLocked = param.isLocked, name = param.name, isCollapsed = param.isCollapsed;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "nav-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "nav-icon-container"
    }, icon ? /*#__PURE__*/ React.createElement(Icon, {
        className: "nav-icon",
        icon: icon
    }) : null, isLocked ? /*#__PURE__*/ React.createElement(Icon, {
        icon: "lock",
        className: "original"
    }) : null), text(name)), /*#__PURE__*/ React.createElement("div", {
        className: "caret-icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: cn({
            'caret-right': !isBoolean(isCollapsed),
            'caret-up': isBoolean(isCollapsed) && isCollapsed,
            'caret-down': isBoolean(isCollapsed) && !isCollapsed
        })
    })));
};
NavLinkContent.propTypes = {
    icon: T.string,
    isLocked: T.bool,
    name: T.string.isRequired,
    isCollapsed: T.bool
};
var NavLink = function(_param) {
    var _param_isCaretHighlighted = _param.isCaretHighlighted, isCaretHighlighted = _param_isCaretHighlighted === void 0 ? true : _param_isCaretHighlighted, _param_isBorderHighlighted = _param.isBorderHighlighted, isBorderHighlighted = _param_isBorderHighlighted === void 0 ? true : _param_isBorderHighlighted, className = _param.className, name = _param.name, onClick = _param.onClick, _param_href = _param.href, href = _param_href === void 0 ? '#' : _param_href, isCollapsed = _param.isCollapsed, icon = _param.icon, _param_isLocked = _param.isLocked, isLocked = _param_isLocked === void 0 ? false : _param_isLocked, rest = _object_without_properties(_param, [
        "isCaretHighlighted",
        "isBorderHighlighted",
        "className",
        "name",
        "onClick",
        "href",
        "isCollapsed",
        "icon",
        "isLocked"
    ]);
    var isUpgradeRecommended = useSelector(profileSelectors.getIsUpgradeRecommended);
    var view3dTooltipText = isUpgradeRecommended ? text('upgradeToView3dTooltip') : text('startTrialToView3dTooltip');
    var navLinkProps = _object_spread({
        className: cn({
            'is-caret-highlighted': isCaretHighlighted,
            'is-border-highlighted': isBorderHighlighted,
            'is-locked': isLocked
        }, className),
        href: href,
        eventKey: name,
        onClick: onClick
    }, rest);
    var navLink = /*#__PURE__*/ React.createElement(Nav.Link, navLinkProps, /*#__PURE__*/ React.createElement(NavLinkContent, {
        icon: icon,
        isLocked: isLocked,
        name: name,
        isCollapsed: isCollapsed
    }));
    return isLocked ? /*#__PURE__*/ React.createElement(OverlayTrigger, {
        placement: "right",
        delay: {
            show: 250
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, null, view3dTooltipText)
    }, navLink) : navLink;
};
NavLink.propTypes = {
    href: T.string,
    name: T.string.isRequired,
    onClick: T.func,
    isCollapsed: T.bool,
    isCaretHighlighted: T.bool,
    isBorderHighlighted: T.bool,
    className: T.string,
    icon: T.string,
    isLocked: T.bool
};
export default NavLink;
